// Type-safe route definitions
export const routes = {
	// Auth
	authCallback: '/auth/callback',
	// Main pages
	dashboard: '/dashboard',
	settings: '/settings',
} as const;

// Type for all route paths
export type RoutePath = (typeof routes)[keyof typeof routes];

// Helper to ensure only valid routes are used
export function isValidRoute(path: string): path is RoutePath {
	return Object.values(routes).includes(path as RoutePath);
}
